import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "@mui/material";

export const ResetAllFiltersButton = () => {
  const navigate = useNavigate();
  const { pathname, search } = useLocation();

  const resetAllFilters = () => {
    const searchParams = new URLSearchParams(search);

    [
      "industries",
      "regions",
      "sizes",
      "date",
      "trend",
      "status_filter",
      "buyer_journey",
    ].forEach((query) => searchParams.delete(query));

    const newQuery = searchParams.toString();
    const queryString = newQuery ? `?${newQuery}` : "";
    navigate(`${pathname}${queryString}`, { replace: true });
  };

  return (
    <Button
      onClick={resetAllFilters}
      sx={{
        textDecoration: "underline",
        whiteSpace: "nowrap",
        background: "none",
        color: "#1C3C6C",
        height: "40px",
      }}
    >
      Reset All
    </Button>
  );
};
